const settings = {
  distanceUnits: [
    {
      label: "KM",
      value: "km",
      square: "km²",
      rate2Km: 1,
    },
    {
      label: "Miles",
      value: "miles",
      square: "sqmi.",
      rate2Km: 1.60934,
    },
  ],
  themes: [
    { value: "light", label: "Light" },
    { value: "dark", label: "Dark" },
  ],
  languages: [
    { value: "co", label: "Corsu" },
    { value: "de", label: "Deutsch" },
    { value: "en", label: "English" },
    { value: "es", label: "Español" },
    { value: "eu", label: "Euskara" },
    { value: "fr", label: "Français" },
    { value: "hu", label: "Magyar" },
    { value: "ja", label: "日本語" },
    { value: "nl", label: "Nederlands" },
    { value: "pl", label: "Polski" },
    { value: "pt", label: "Português" },
  ],
};

export default settings;
